(function () {
  'use strict';

  if (window.TheoricShare && window.TheoricShare.__initialized) {
    return;
  }

  const SHARE_BUTTON_SELECTOR = '[data-theoric-share-button]';
  const COPIED_LABEL = 'Link copiado';

  function getShareTitle(button) {
    return button.getAttribute('data-share-title') || document.title;
  }

  function getShareUrl(button) {
    return button.getAttribute('data-share-url') || window.location.href;
  }

  function showCopiedState(button) {
    const originalLabel = button.getAttribute('aria-label') || 'Compartilhar produto';
    button.classList.add('is-copied');
    button.setAttribute('aria-label', COPIED_LABEL);

    window.setTimeout(function () {
      button.classList.remove('is-copied');
      button.setAttribute('aria-label', originalLabel);
    }, 1800);
  }

  async function fallbackShare(url, button) {
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(url);
        showCopiedState(button);
        return;
      }
    } catch (error) {
      // no-op
    }

    window.prompt('Copie o link do produto:', url);
  }

  async function handleShareClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const url = getShareUrl(button);
    const title = getShareTitle(button);

    if (navigator.share && typeof navigator.share === 'function') {
      try {
        await navigator.share({ title: title, url: url });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }
      }
    }

    await fallbackShare(url, button);
  }

  function getButtons(root) {
    if (!root) return [];
    if (root.matches && root.matches(SHARE_BUTTON_SELECTOR)) return [root];
    if (!root.querySelectorAll) return [];
    return Array.from(root.querySelectorAll(SHARE_BUTTON_SELECTOR));
  }

  function initShareButtons(root) {
    getButtons(root).forEach(function (button) {
      if (button.dataset.shareBound === 'true') return;
      button.dataset.shareBound = 'true';
      button.addEventListener('click', handleShareClick);
    });
  }

  function init() {
    initShareButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TheoricShare = {
    __initialized: true,
    initShareButtons: initShareButtons
  };

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initShareButtons(event.target);
  });

  document.addEventListener('theoric:share:refresh', function (event) {
    const root = event && event.detail ? event.detail.root : null;
    initShareButtons(root || document);
  });
})();
